var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 7.5,
    stroke: "#6C6C9A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8917 11.1095C22.9893 9.20684 21.1261 9.1578 19.1747 11.1095L17.9881 12.2963C17.89 12.3943 17.8508 12.5513 17.89 12.6886C18.6353 15.2876 20.7142 17.3669 23.3129 18.1122C23.3521 18.122 23.3913 18.1319 23.4306 18.1319C23.5384 18.1319 23.6365 18.0926 23.715 18.0142L24.8917 16.8274C25.8625 15.8663 26.3332 14.9345 26.3332 13.993C26.343 13.022 25.8723 12.0805 24.8917 11.1095Z",
    fill: "#3F2F5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5475 18.9996C21.2631 18.8623 20.9885 18.725 20.7237 18.5681C20.508 18.4406 20.3021 18.3033 20.0961 18.1562C19.9294 18.0483 19.7333 17.8914 19.547 17.7344C19.5274 17.7246 19.4587 17.6658 19.3803 17.5873C19.0567 17.3127 18.6938 16.9596 18.3702 16.5673C18.3408 16.5477 18.2918 16.479 18.2231 16.3908C18.1251 16.2731 17.9584 16.0769 17.8113 15.8513C17.6936 15.7042 17.5563 15.4885 17.4288 15.2727C17.2719 15.0079 17.1346 14.7431 16.9974 14.4685C16.9788 14.4286 16.9607 14.3889 16.9431 14.3494C16.7949 14.0164 16.3603 13.9188 16.1026 14.1766L10.4958 19.7842C10.3683 19.9117 10.2506 20.1569 10.2212 20.3237L9.69169 24.08C9.59362 24.7469 9.77994 25.3746 10.1918 25.7964C10.5448 26.1396 11.0351 26.326 11.5647 26.326C11.6824 26.326 11.8 26.3162 11.9177 26.2966L15.6833 25.7669C15.8598 25.7375 16.105 25.6198 16.2227 25.4923L21.8224 19.8917C22.0819 19.6322 21.9841 19.1866 21.6466 19.0423C21.6139 19.0283 21.5809 19.0141 21.5475 18.9996Z",
    fill: "#3F2F5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit1);
export default __webpack_public_path__ + "static/media/edit1.7990caacee8d3411b224cf95d8147f09.svg";
export { ForwardRef as ReactComponent };